import { useState, useEffect, useCallback } from 'react';
import {
  ENGLISH_EXERCISES,
  type EnglishExercise,
  type ExerciseDifficulty,
} from '../data/englishExercises';

interface UseEnglishExerciseResult {
  exercise: EnglishExercise | null;
  loading: false;
  error: null;
  refresh: () => void;
}

let lastId: string | null = null;

function pick(difficulty: ExerciseDifficulty | null): EnglishExercise | null {
  const pool = difficulty
    ? ENGLISH_EXERCISES.filter((e) => e.difficulty === difficulty)
    : ENGLISH_EXERCISES;
  if (pool.length === 0) return null;
  const candidates = pool.length > 1 ? pool.filter((e) => e.id !== lastId) : pool;
  const chosen = candidates[Math.floor(Math.random() * candidates.length)] ?? null;
  if (chosen) lastId = chosen.id;
  return chosen;
}

export function useEnglishExercise(
  difficulty: ExerciseDifficulty | null,
): UseEnglishExerciseResult {
  const [exercise, setExercise] = useState<EnglishExercise | null>(() => pick(difficulty));
  const [counter, setCounter] = useState(0);

  // Re-pick when difficulty or counter changes
  useEffect(() => {
    setExercise(pick(difficulty));
  }, [difficulty, counter]);

  const refresh = useCallback(() => setCounter((c) => c + 1), []);

  return { exercise, loading: false, error: null, refresh };
}
